import axios from 'axios'
import TopPoster from 'components/body/TopPoster'
import GoogleTagManagerAttributes from 'components/core/GoogleTagManagerAttributes'
import Footer from 'components/layout/Footer'
import MainMenu from 'components/layout/MainMenu'
import PreviewNotice from 'components/layout/PreviewNotice'
import TopMenuBar from 'components/layout/TopMenuBar'
import BodyRenderer from 'components/renderers/BodyRenderer'
import HeaderContainer from 'components/renderers/HeaderContainer'
import HeroRenderer from 'components/renderers/HeroRenderer'
import PageSeo from 'components/seo/PageSeo'
import Env from 'Env'
import HTTPMethod from 'http-method-enum'
import { TopPosterModel } from 'models/body/TopPosterModel'
import { AppInfoModel } from 'models/config/AppInfoModel'
import { MenuModel } from 'models/menu/MenuModel'
import { PageModel } from 'models/page/PageModel'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { ApiPromise } from 'services/ApiPromise'
import { Converters } from 'services/Converters'

type PathsParamsType = {
  params: { slug: string }
}

type Props = {
  page: PageModel
  menu: MenuModel
  footer: MenuModel
  isPreview: boolean
  posters: {
    data: TopPosterModel[]
  }
  appConfig: AppInfoModel
}

const DynamicPage: NextPage<Props> = (props) => {
  const pageAttributes = props.page.data.attributes
  const posters = props.posters.data
  return (
    <Fragment>
      <GoogleTagManagerAttributes />
      <PageSeo title={pageAttributes.title} seo={pageAttributes.seo} />
      {props.isPreview ? <PreviewNotice /> : null}

      <HeaderContainer posters={props.posters} menu={props.menu} />
      
      {pageAttributes.hero.map((hero, index) => {
        return <HeroRenderer key={index} data={hero} />
      })}
      {pageAttributes.body.map((section, index) => {
        return <BodyRenderer key={index} data={section} />
      })}
      <Footer data={props.footer} />
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  try{
    const isPreview = context.preview
    const slug = context.params?.slug as string
    const allPromises = ApiPromise.Page.GetPageWithHeaderFooter(slug, isPreview)
    const [menuPromise, pagePromise, footerPromise, postersPromise] = await Promise.all(allPromises)
    const [menu, page, footer, posters] = Converters.KeysConvert.ConvertAllToLower([menuPromise.data, pagePromise.data, footerPromise.data, postersPromise.data])
    const appConfig = await ApiPromise.Layout.AppConfig()
    return { props: { page, menu, footer, posters, appConfig, isPreview: isPreview ? true : false }, revalidate: Env.PropsRevalidateTime }
  }catch{
    return {
      notFound: true,
    }
  }
}

export const getStaticPaths: GetStaticPaths = async (context) => {
  const allPagesRoute = '/pages'
  const resp = await axios({
    method: HTTPMethod.GET,
    baseURL: Env.ApiUrl,
    url: allPagesRoute,
  })
  const pageRecordsData: any[] = resp.data['data']

  const pageSlugRecords: PathsParamsType[] = []
  pageRecordsData.map((page) => {
    const isThePageHome = page.attributes.Slug === 'home'
    if (!isThePageHome) {
      pageSlugRecords.push({ params: { slug: page.attributes.Slug } })
    }
  })

  return {
    paths: pageSlugRecords,
    fallback: 'blocking',
  }
}

export default DynamicPage
